import { render, staticRenderFns } from "./AssistantF2FProcessCountChart.vue?vue&type=template&id=1283c6bc"
import script from "./AssistantF2FProcessCountChart.vue?vue&type=script&lang=js"
export * from "./AssistantF2FProcessCountChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports